(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/wheel/assets/javascripts/wheel.js') >= 0) return;  svs.modules.push('/components/tur/wheel/assets/javascripts/wheel.js');


var svs = svs || {};

(function(svs) {
  'use strict';

  svs.tur = svs.tur || {};

  var Wheel = function(options) {
    if (options.isStar) {
      options.maxValue = options.extraMaxValue;
    }
    var self = this;
    var i;
    var num;
    var transform;
    var r = 0;
    var containerDiv;
    var degAdjust = 360;
    var upArrowDiv;
    var downArrowDiv;
    var maskDiv;
    var wheelBackgroundCircle;
    var wheelForegroundCircle;
    var wheelHolder = 'wheel-holder';
    var wheelClass = 'wheel-numbers';
    var wheelDeviceClass = svs.core.detect.formfactor.desktop() ? 'wheel-is-desktop' : 'wheel-is-mobile';
    var containerClass = 'wheel-container ' + wheelDeviceClass;

    containerClass += options.isStar ? ' wheel-container-markedextra' : '';

    if (options.hidden && !options.useFallback) {
      wheelClass += ' invisible';
    } else {
      containerClass += ' wheel-container-selected';
    }

    if (options.useFallback) {
      containerClass += ' wheel-fallback';
    }

    containerDiv = document.createElement('div');
    containerDiv.setAttribute('data-index', options.wheelIndex);
    this.$el = $(containerDiv).addClass(containerClass);
    this.domWheel = document.createElement('div');
    this.$wheel = $(this.domWheel).addClass(wheelClass);
    this.$wheelHolder = $(document.createElement('div')).addClass(wheelHolder);
    this.$el.append(this.$wheelHolder);
    this.$wheelHolder.append(this.$wheel);

    this.numElements = [];
    this.currentDeg = 0;
    this.wheelIndex = options.wheelIndex;
    this.options = options;
    this.value = options.value;
    this.index = options.value;
    this.minIndex = options.minValue;
    this.maxIndex = options.maxValue * (options.repeat + 1);
    this.lastDeltaY = 0;
    this.numberDeg = 360 / (options.maxValue * (options.repeat + 1));
    this.board = options.board;
    this.isSpinning = false;
    this.fullRange = this.maxIndex;

    if (!options.useFallback) {
      while (r <= options.repeat) {
        r++;

        for (i = options.minValue; i <= options.maxValue; i++) {
          var selectedClass = this.value === i ? 'selected-number' : '';
          num = document.createElement('span');
          num.className = 'wheel-number wheel-index-' + this.wheelIndex + ' wheel-number-' + i + ' ' + selectedClass;
          num.innerHTML = i;

          transform = 'rotateX(' + degAdjust + 'deg) translateZ(' + options.maxValue * (options.repeat + 1) * options.spacingFactor + 'px)';

          num.style.webkitTransform = transform;
          num.style.MozTransform = transform;
          num.style.msTransform = transform;
          num.style.OTransform = transform;
          num.style.transform = transform;

          this.numElements.push(num);

          degAdjust -= this.numberDeg;
        }
      }
    } else if (!svs.core.detect.formfactor.desktop()) {
      this.$fallbackSelectContainer = $('<div class="wheel-select-container"></div>');
      this.$fallbackSelect = $('<select></select>');
      for (i = options.minValue; i <= options.maxValue; i++) {
        this.$fallbackSelect.append('<option value="' + i + '"' + (i === this.value ? ' selected' : '') + '>' + i + '</option>');
      }
      this.$el.append(this.$fallbackSelectContainer.append(this.$fallbackSelect));
      this.$fallbackSelect.css('padding-left', this.value < 10 ? '7px' : '0');
      this.$fallbackSelect.on('change', function(event, manual) {
        if (manual) {
          this.value = self.value;
        } else {
          self.index = parseInt(this.value, 10);
          self.updateValue();
          self.options.onWheelChanged && self.options.onWheelChanged(self);
        }
        self.$fallbackSelect.css('padding-left', this.value < 10 ? '7px' : '0');
        for (var wheel, i = 0; i < self.board.wheels.length; i++) {
          wheel = self.board.wheels[i];
          wheel.$fallbackSelect.find('option').each(function() {
            $(this).prop('disabled', !self.board.numberIsValid(this.value, wheel));
          });
        }
        self.$el.addClass('wheel-container-selected');
      });
    } else {
      this.fallBackDesktopRender();
    }

    if (!svs.core.detect.formfactor.desktop()) {
      upArrowDiv = document.createElement('div');
      upArrowDiv.className = 'wheel-arrow wheel-arrow-up';
      this.$el.prepend(upArrowDiv);
    }

    wheelBackgroundCircle = document.createElement('div');
    wheelBackgroundCircle.className = 'wheel-background-circle';
    this.$el.prepend(wheelBackgroundCircle);

    if (!svs.core.detect.formfactor.desktop()) {
      this.$upArrow = $(upArrowDiv);
      this.$upArrow.click(function() {
        self.step(1);
      });

      downArrowDiv = document.createElement('div');
      downArrowDiv.className = 'wheel-arrow wheel-arrow-down';
      this.$el.append(downArrowDiv);

      this.$downArrow = $(downArrowDiv);

      this.$downArrow.click(function() {
        self.step(-1);
      });
    }

    maskDiv = document.createElement('div');
    maskDiv.className = 'wheel-mask';
    this.$el.append(maskDiv);

    wheelForegroundCircle = document.createElement('div');
    wheelForegroundCircle.className = 'wheel-foreground-circle';
    this.$el.append(wheelForegroundCircle);

    this.currentDeg = this.numberDeg * (this.value - 1);

    if (!svs.core.detect.formfactor.desktop()) {
      $(this.$wheel).on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function() {
        self.$el.removeClass('wheel-container-invalid').addClass('wheel-container-selected');
        self.options.onWheelChanged && self.options.onWheelChanged(self);
      });
    }

    if (!options.animate) {
      this.render(7, true);
      this.rotate(0);
    }
  };

  Wheel.prototype.render = function(range, noValueUpdate) {
    var i,
      html = [],
      numbersToShow,
      start,
      end,
      leading = Math.floor(range / 2),
      trailing = Math.round(range / 2);

    if (range !== this.$wheel.children().length && !this.options.useFallback) {
      if (!noValueUpdate) {
        this.updateIndex();
      }

      start = this.index - leading - 1;
      end = this.index + trailing - 1;

      numbersToShow = this.numElements;
      if (start < 0 || start + end > numbersToShow.length) {
        numbersToShow = numbersToShow.concat(numbersToShow);
      }
      if (start < 0) {
        start += this.maxIndex;
        end += this.maxIndex;
      }
      numbersToShow = numbersToShow.slice(start, end);

      i = numbersToShow.length;
      while (i--) {
        html.push(numbersToShow[i].outerHTML);
      }
      html.reverse();
      this.domWheel.innerHTML = html.join('');

      var cls = '.wheel-index-' + this.wheelIndex;
      $(cls).removeClass('selected-number');
    }
  };

  Wheel.prototype.rotate = function(deltaY, duration, direction) {
    var self = this;
    duration = duration || 0;

    this.currentDirection = direction || deltaY > this.lastDeltaY ? 0 : 1;
    this.currentDeg = this.currentDeg + (this.lastDeltaY - deltaY) * 0.3;

    if (!this.options.useFallback) {
      this.$wheel.css({
        transition: 'transform ' + duration + 'ms ease-out',
        '-webkit-transition': '-webkit-transform ' + duration + 'ms ease-out',
        '-webkit-transform': 'rotateX(' + this.currentDeg + 'deg)',
        '-ms-transform': 'rotateX(' + this.currentDeg + 'deg)',
        transform: 'rotateX(' + this.currentDeg + 'deg)'
      });
      if (duration && svs.core.detect.formfactor.desktop()) {
        $('.wheel-container.wheel-container-markedextra').removeClass('selected-hover');
        this.rotateRedrawTimeout && clearTimeout(this.rotateRedrawTimeout);
        this.rotateRedrawTimeout = setTimeout(function() {
          requestAnimationFrame(function() {
            self.$wheel[0].style.display = 'none';
            self.$wheel[0].offsetHeight; 
            self.$wheel[0].style.display = 'block';
            self.options.onWheelChanged && self.options.onWheelChanged(self);
            var cls = '.wheel-index-' + self.wheelIndex + '.wheel-number-' + self.value;
            $(cls).addClass('selected-number');
            $(self.$el).addClass('selected-hover');
          });
        }, duration);
      } else if (svs.core.detect.formfactor.mobile()) {
        $('.wheel-container.wheel-container-markedextra').removeClass('selected-hover');
        setTimeout(function() {
          var cls = '.wheel-index-' + self.wheelIndex + '.wheel-number-' + self.value;
          $(cls).addClass('selected-number');
        }, duration);
      }
    }
    this.lastDeltaY = deltaY;
  };

  Wheel.prototype.step = function(step) {
    var duration = 400;
    var self = this;
    this.render(this.fullRange);
    this.$el.removeClass('wheel-container-selected');
    this.currentDeg += this.numberDeg * step;
    this.rotate(0, duration);
    this.index = this.index + step;
    this.index = this.index > this.maxIndex ? this.minIndex : this.index < this.minIndex ? this.maxIndex : this.index;
    this.updateValue();
    if (this.options.useFallback) {
      if (this.$fallbackSelect) {
        this.$fallbackSelect.trigger('change', true);
      } else {
        this.fallBackDesktopRender();
      }
      this.options.onWheelChanged && this.options.onWheelChanged(this);
    }

    if (!this.board.numberIsValid(this.value, this)) {
      if (!this.options.useFallback) {
        this.$el.addClass('wheel-container-invalid');
      }
      this.step(step < 0 ? -1 : 1);
    }
    setTimeout(function() {
      var cls = '.wheel-index-' + self.wheelIndex + '.wheel-number-' + self.value;
      $(cls).addClass('selected-number');
    }, duration);
  };

  Wheel.prototype.updateIndex = function() {
    this.index = this.nearestIndex(this.currentDeg);
  };

  Wheel.prototype.nearestIndex = function(deg) {
    var closestNumber, absNumber, realNumber;

    closestNumber = Math.round(deg / this.numberDeg);
    absNumber = closestNumber % this.maxIndex;
    realNumber = absNumber <= 0 ? this.maxIndex + absNumber : absNumber;
    realNumber += 1;

    return realNumber;
  };

  Wheel.prototype.updateValue = function() {
    var cls = '.wheel-index-' + this.wheelIndex;
    $(cls).removeClass('selected-number');
    this.value = this.valueFromIndex(this.index);
  };

  Wheel.prototype.valueFromIndex = function(index) {
    if (index < this.minIndex) {
      index = this.maxIndex;
    } else if (index > this.maxIndex) {
      index = this.minIndex;
    }
    if (this.options.repeat > 1) {
      index = index % this.options.maxValue;
      index = index || this.options.maxValue;
    }
    return index;
  };

  Wheel.prototype.scrollStart = function() {
    var cls = '.wheel-index-' + this.wheelIndex + '.wheel-number-' + this.value;
    $(cls).removeClass('selected-number');
    this.isSpinning = true;
    this.$el.removeClass('wheel-container-selected');
    this.render(this.fullRange);
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = 0;
    }
    this.$wheel.css({
      transition: 'none',
      '-webkit-transition': 'none'
    });
  };

  Wheel.prototype.scrollEnd = function(event) {
    var targetDeg,
      distance,
      targetValue,
      targetIndex,
      duration,
      deltaY = event.deltaY,
      velocityY = event.velocityY,
      deltaTime = event.deltaTime;

    distance = deltaY * (velocityY / 2);

    if (deltaY < 0) {
      distance *= -1;
    }

    targetDeg = this.currentDeg - distance;

    duration = deltaTime * (velocityY / 0.75) * 4;

    if (targetDeg % this.numberDeg !== 0) {
      targetDeg = Math.round(targetDeg / this.numberDeg) * this.numberDeg;
      targetIndex = this.nearestIndex(targetDeg);

      if (targetIndex < 1) {
        targetIndex = this.options.maxIndex + targetIndex;
      }

      if (targetIndex < this.minIndex) {
        targetIndex = this.maxIndex;
      } else if (targetIndex > this.maxIndex) {
        targetIndex = this.minIndex;
      }

      targetValue = this.valueFromIndex(targetIndex);

      while (!this.board.numberIsValid(targetValue, this)) {
        this.$el.addClass('wheel-container-invalid');
        targetIndex += this.currentDirection ? 1 : -1;
        duration += 200;
        targetDeg += this.currentDirection ? this.numberDeg : -this.numberDeg;
        if (targetIndex < this.minIndex) {
          targetIndex = this.maxIndex;
        } else if (targetIndex > this.maxIndex) {
          targetIndex = this.minIndex;
        }
        targetValue = this.valueFromIndex(targetIndex);
      }
      this.index = targetIndex;
      this.updateValue();
      var cls = '.wheel-index-' + this.wheelIndex + '.wheel-number-' + this.value;
      $(cls).addClass('selected-number');

      if (duration === 0) {
        duration = 1;
      } else if (duration < 0) {
        duration *= -1;
      }

      this.$wheel.css({
        transition: 'transform ' + duration + 'ms',
        '-webkit-transition': '-webkit-transform ' + duration + 'ms',
        '-webkit-transform': 'rotateX(' + targetDeg + 'deg)',
        '-ms-transform': 'rotateX(' + targetDeg + 'deg)',
        transform: 'rotateX(' + targetDeg + 'deg)'
      });
    }
    this.currentDeg = targetDeg;
    this.isSpinning = false;
  };

  Wheel.prototype.fallBackDesktopRender = function(index) {
    var i, spanNr;

    index = index || this.index;

    this.$wheelHolder.find('span').remove();
    for (i = -2; i < 3; i++) {
      if (i !== 0) {
        spanNr = index + i;
        if (spanNr > this.options.maxValue) {
          spanNr += -this.options.maxValue;
          spanNr = spanNr !== 0 ? spanNr : this.options.minValue;
        } else if (spanNr < this.options.minValue) {
          spanNr += this.options.maxValue;
        }
        this.$wheelHolder.append('<span class="block align-center" style="margin-top: ' + (i !== -2 ? i === 1 ? 60 : 20 : 0) + 'px">' + spanNr + '</span>');
      }
    }
    this.$wheel.text(index);
  };

  var Board = function(options) {
    var i;
    this.onHuxfluxComplete = options.onHuxfluxComplete;
    this.index = options.index;
    $.extend(options, { board: this });
    this.wheels = [];
    this.$el = $(document.createElement('div'))
      .addClass('board')
      .css({
        left: options.elementWidth * this.index,
        width: options.elementWidth
      });
    for (i = 0; i < 5; i++) {
      this.wheels.push(
        new Wheel(
          $.extend(options, {
            value: options.values[i],
            wheelIndex: i
          })
        )
      );
      this.$el.append(this.wheels[i].$el);
    }
    for (i = 5; i < 7; i++) {
      this.wheels.push(
        new Wheel(
          $.extend({}, options, {
            repeat: 4,
            isStar: true,
            value: options.values[i],
            wheelIndex: i
          })
        )
      );
      this.$el.append(this.wheels[i].$el);
    }
  };

  Board.prototype.animate = function() {
    var timeBetweenNumbers = 200,
      wheelSpeed = 500,
      i,
      speedPerNumber = wheelSpeed / 360,
      self = this,
      animationTime,
      j;

    for (i = 0; i < 7; i++) {
      if (!this.wheels[i].options.useFallback) {
        setTimeout(
          (function(i) {
            self.wheels[i].isSpinning = true;
            var e = i + 1;
            var target = self.wheels[i].currentDeg;
            self.wheels[i].render(self.wheels[i].fullRange, true);
            self.wheels[i].$wheel.removeClass('invisible');
            self.wheels[i].$el.removeClass('wheel-container-selected');
            return function() {
              animationTime = wheelSpeed + timeBetweenNumbers * e;
              self.wheels[i].currentDeg = target;
              self.wheels[i].rotate(0, animationTime);

              setTimeout(function() {
                self.wheels[i].$el.removeClass('wheel-container-invalid').addClass('wheel-container-selected');
                i === 6 && self.onHuxfluxComplete && self.onHuxfluxComplete(self.wheels);
                self.wheels[i].isSpinning = false;
              }, animationTime);
            };
          })(i),
          10
        );
        self.wheels[i].currentDeg -= timeBetweenNumbers / speedPerNumber * self.wheels[i].numberDeg;
        self.wheels[i].rotate(0);
      } else if (!svs.core.detect.formfactor.desktop()) {
        self.wheels[i].$fallbackSelect.trigger('change', true);
        i === 6 && self.onHuxfluxComplete && self.onHuxfluxComplete(self.wheels);
      } else {
        for (j = 0; j <= 10; j++) {
          setTimeout(
            (function(i, j) {
              return function() {
                setTimeout(function() {
                  if (j === 10) {
                    self.wheels[i].fallBackDesktopRender();
                    if (i === 6) {
                      self.onHuxfluxComplete && self.onHuxfluxComplete(self.wheels);
                    }
                  } else {
                    self.wheels[i].fallBackDesktopRender(Math.random() * (self.wheels[i].options.maxValue - self.wheels[i].options.minValue) + self.wheels[i].options.minValue | 0);
                  }
                }, 150 * j);
              };
            })(i, j),
            10
          );
        }
      }
    }
  };

  Board.prototype.numberIsValid = function(num, currentWheel) {
    var i = 0,
      iLen = 4,
      wheel;

    num = parseInt(num, 10);

    if (currentWheel.options.isStar) {
      i = 5;
      iLen = 6;
    }
    while (i <= iLen) {
      wheel = this.wheels[i];
      if (wheel !== currentWheel && wheel.value === num) {
        return false;
      }
      i++;
    }
    return true;
  };

  Board.prototype.huxflux = function(row) {
    var wheel;

    for (var i = 0; i < this.wheels.length; i++) {
      wheel = this.wheels[i];
      wheel.isSpinning = true;
      wheel.index = row[i];
      wheel.currentDeg = wheel.numberDeg * (wheel.index - 1);
      wheel.updateValue();
    }
    this.animate();
  };

  svs.tur.EJBoards = function($target, options) {
    var self = this,
      currentPosition,
      currentWheel,
      dragState = 0,
      i;

    this.boards = [];
    if (!($target instanceof jQuery)) {
      $target = $($target);
    }

    this.options = {};
    this.position = 0;
    this.activeIndex = 0;
    this.currentWheel = undefined;
    this.disableHorizontalSwipe = options && options.disableHorizontalSwipe;

    $target.css({ height: svs.core.detect.formfactor.mobile() ? 165 : 230 });
    $.extend(this.options, svs.tur.EJBoards.Defaults, options);
    if (!this.options.responsiveWidth) this.setWidth();
    this.$el = $(document.createElement('div')).addClass('boards');
    this.$el.css({ left: 0 });
    this.hammertime = window.Hammer(this.$el.get(0));
    this.hammertime.get('pan').set({ direction: window.Hammer.DIRECTION_ALL });

    if (svs.core.detect.formfactor.desktop()) {
      this.$matrix = $('<div class="wheel-matrix normal"><div class="arrow-container"><div class="arrow-up"></div></div><p>Välj nummer</p></div>');
      for (i = 1; i <= options.maxValue; i++) {
        this.$matrix.append('<span data-value="' + i + '">' + i + '</span>');
      }
      $target.after(this.$matrix);
      this.$matrixstar = $('<div class="wheel-matrix star"><div class="arrow-container"><div class="arrow-up"></div></div><p>Välj stjärnnummer</p></div>');
      for (i = 1; i <= options.extraMaxValue; i++) {
        this.$matrixstar.append('<span data-value="' + i + '">' + i + '</span>');
      }
      $target.after(this.$matrixstar);

      self.$matrix.mouseleave(function() {
        self.hideMatrix();
      });
      self.$matrix.find('span').click(function(e) {
        self.numberFromMatrix(e, self.$matrix);
      });
      self.$matrixstar.mouseleave(function() {
        self.hideMatrix();
        $('.wheel-container.wheel-container-markedextra').removeClass('selected-hover');
      });
      self.$matrixstar.find('span').click(function(e) {
        self.numberFromMatrix(e, self.$matrixstar);
      });
      this.$el.on('mouseover', function(event) {
        if (dragState === 0 && !this.isSpinning) {
          $('.wheel-container.wheel-container-markedextra').addClass('selected-hover');
          self.toggleMatrix(self.boards[self.activeIndex].wheels[event.target.offsetParent.dataset.index]);
        }
      });
      this.$el.on('mouseleave', function(event) {
        if (dragState === 0) {
          if (
            !$(event.relatedTarget).hasClass('wheel-matrix') &&
            !$(event.relatedTarget)
              .parent()
              .hasClass('wheel-matrix')
          ) {
            self.hideMatrix();
          }
        }
      });

      function handleScroll(event) {
        var step;
        if (svs.core.data.capabilities.browser !== 'trident' && (self.$matrix.is(':visible') || self.$matrixstar.is(':visible'))) {
          event.preventDefault();
          if (event.type === 'keydown' && event.which >= 37 && event.which <= 40) {
            step = event.keyCode === 37 || event.keyCode === 38 ? -1 : 1;
          } else {
            step = event.detail > 0 || event.wheelDelta < 0 ? 1 : -1;
          }
          self.currentWheel.step(step);
          self.toggleMatrixNumbers(self.currentWheel.options.isStar ? self.$matrixstar : self.$matrix, self.currentWheel);
          self.currentWheel.$el.removeClass('wheel-container-invalid');
        }
      }
      document.body.addEventListener('DOMMouseScroll', handleScroll, { passive: false });
      document.body.addEventListener('mousewheel', handleScroll, { passive: false });

      $(document).on('keydown', handleScroll);

    } else if (!this.options.useFallback) {
      this.hammertime.on('panup pandown swipeup swipedown', function(event) {
        if (dragState === 0) {
          currentWheel = self.boards[self.activeIndex].wheels[event.target.offsetParent.dataset.index];
          if (currentWheel.isSpinning) {
            return;
          }
          currentWheel.scrollStart();
          dragState = 2;
          currentWheel.$el.removeClass('wheel-container-invalid');
        }
        if (dragState === 2) {
          event.preventDefault();
          event.srcEvent.cancelBubble = true;
          currentWheel.rotate(event.deltaY);
        }
      });
    }

    !this.disableHorizontalSwipe && this.hammertime.on('panleft panright swipeleft swiperight', function(event) {
      if (svs.core.detect.formfactor.desktop()) {
        self.hideMatrix();
      }
      if (dragState === 0) {
        self.$el.css({ '-webkit-transition': 'none', transition: 'none' });
        self.renderAll(7);
        dragState = 1;
      }
      if (dragState === 1) {
        event.preventDefault();
        event.srcEvent.cancelBubble = true;
        currentPosition = event.deltaX + self.position;
        self.$el.css({ left: currentPosition });
      }
    });

    this.hammertime.on('panend', function(event) {
      if (dragState === 1) {
        self.position = currentPosition;
        if (event.distance > self.swipeThreshold) {
          if (event.additionalEvent === 'panright' && self.activeIndex > 0) {
            self.activeIndex -= 1;
            self.options.onBoardChanged && self.options.onBoardChanged(self.activeIndex);
          } else if (event.additionalEvent === 'panleft' && self.activeIndex < self.boards.length - 1) {
            self.activeIndex += 1;
            self.options.onBoardChanged && self.options.onBoardChanged(self.activeIndex);
          }
        }
        self.position = -(self.elementWidth * self.activeIndex);
        self.$el.css({ left: self.position, '-webkit-transition': 'all 0.6s', transition: 'all 0.6s' });
      } else if (dragState === 2) {
        currentWheel.scrollEnd(event);
        currentWheel.lastDeltaY = 0;
      }
      setTimeout(function() {
        dragState = 0;
      }, 10);
    });

    $target.append(this.$el);

    return this;
  };

  svs.tur.EJBoards.prototype.setWidth = function() {
    var i, board;

    this.elementWidth = Math.max(Math.min(svs.core.detect.viewport.width(), 740), parseInt($('body').css('min-width'), 10));
    this.elementWidth -= svs.core.detect.formfactor.mobile() && 12;
    this.swipeThreshold = this.elementWidth / 4;

    if (this.$el) {
      this.$el.css({
        width: this.elementWidth * this.boards.length
      });

      for (i = 0; i < this.boards.length; i++) {
        board = this.boards[i];
        board.$el.css({
          width: this.elementWidth,
          left: this.elementWidth * i
        });
      }
    }
  };

  svs.tur.EJBoards.prototype.renderAll = function(num) {
    var board;

    for (var i = 0; i < this.boards.length; i++) {
      board = this.boards[i];
      for (var e = 0; e < board.wheels.length; e++) {
        board.wheels[e].render(num);
      }
    }
  };

  svs.tur.EJBoards.prototype.stop = function() {
    var board;

    for (var i = 0; i < this.boards.length; i++) {
      board = this.boards[i];
      for (var e = 0; e < board.wheels.length; e++) {
        setTimeout(
          (function(wheel) {
            wheel.$wheel.css({ transition: 'none' });
          })(board.wheels[e]),
          10
        );
        board.wheels[e].$el.removeClass('wheel-container-invalid').addClass('wheel-container-selected');
        board.wheels[e].$wheel.removeClass('invisible');
      }
    }
  };

  svs.tur.EJBoards.prototype.goTo = function(index) {
    if (svs.core.detect.formfactor.desktop()) {
      this.hideMatrix();
    }
    this.renderAll(7);
    this.activeIndex = index;
    this.position = -(this.elementWidth * this.activeIndex);
    this.$el.css({ '-webkit-transition': 'all 0.6s', transition: 'all 0.6s' });
    this.$el.css({ left: this.position });
  };

  svs.tur.EJBoards.prototype.addBoard = function(options) {
    var board = new Board(
      $.extend(
        {},
        this.options,
        {
          index: this.boards.length,
          elementWidth: this.elementWidth
        },
        options
      )
    );
    this.$el.append(board.$el);
    this.boards.push(board);
    this.$el.css({ width: this.elementWidth * this.boards.length });
    if (options.animate) {
      board.animate();
    }
  };

  svs.tur.EJBoards.prototype.removeBoard = function(index) {
    var board = this.boards.splice(index, 1)[0];
    var i;
    var iLen;
    if (svs.core.detect.formfactor.desktop()) {
      this.hideMatrix();
    }
    board.$el.remove();
    for (i = index, iLen = this.boards.length; i < iLen; i++) {
      this.boards[i].$el.css('left', this.elementWidth * i);
    }
  };

  svs.tur.EJBoards.prototype.hideMatrix = function() {
    this.$matrix.hide();
    this.$matrixstar.hide();
    $('.wheel-container').addClass('wheel-container-selected');
  };

  svs.tur.EJBoards.prototype.toggleMatrix = function(wheel) {
    if (!wheel || wheel.isSpinning) {
      return;
    }
    var wheelRow = $('.js-eurojackpot-wheel-row');

    var fixedPos = wheelRow.offset().left < this.$matrix.outerWidth() / 2 &&
        wheel.$wheel.offset().left + wheel.$wheel.width() / 2 <
        this.$matrix.outerWidth() / 2 + wheel.$wheel.width() / 2 &&
        wheelRow.offset().left ||
        this.$matrix.outerWidth() > wheelRow.outerWidth();

    var left = wheel.$wheel.offset().left + wheel.$wheel.width() / 2 - (wheel.options.isStar ? 113 : 213);
    var posCss = {
      left: left < 0 ? 0 : left,
      top: wheel.$el.offset().top + 133
    };

    if (this.options.responsiveWidth) {
      var $matrix = wheel.options.isStar ? this.$matrixstar : this.$matrix;
      left = wheel.$wheel.width() * wheel.wheelIndex - $matrix.width() / 2 + wheel.$wheel.width() / 2 - 12;

      if (fixedPos) {
        left = -wheelRow.offset().left / 2;
      }

      posCss = {
        left: left,
        top: 134
      };
    }

    this.currentWheel = wheel;

    this.hideMatrix();

    wheel.$el.removeClass('wheel-container-selected');

    if (wheel.options.isStar) {
      this.toggleMatrixNumbers(this.$matrixstar, wheel);
      if (window.innerWidth < wheel.$wheel.offset().left + this.$matrixstar.outerWidth()) {
        posCss.left = wheel.$wheel.offset().left - this.$matrixstar.outerWidth() + wheel.$wheel.width() / 2;
        this.$matrixstar.find('.arrow-container').css('left', this.$matrixstar.outerWidth() - wheelRow.offset().left - 10);
      } else {
        this.$matrixstar.find('.arrow-container').css('left', wheel.$wheel.width() + 20);
      }
      this.$matrixstar.css(posCss);
      this.$matrixstar.show();
    } else {
      this.toggleMatrixNumbers(this.$matrix, wheel);
      this.$matrix.css(posCss);
      if (fixedPos) {
        this.$matrix.find('.arrow-container').css('left', wheelRow.offset().left / 2 + wheel.$wheel.width() / 2 + (wheel.$wheel.width() * wheel.wheelIndex) - 10);
      } else {
        this.$matrix.find('.arrow-container').css('left', this.$matrix.outerWidth() / 2 - 10);
      }
      this.$matrix.show();
    }
  };

  svs.tur.EJBoards.prototype.numberFromMatrix = function(e, $matrix) {
    if (!this.currentWheel || this.currentWheel.isSpinning || $(e.target).hasClass('disabled')) {
      return;
    }
    var wheel = this.currentWheel;
    wheel.index = Number(e.target.dataset.value);
    wheel.currentDeg = wheel.numberDeg * (wheel.index - 1);
    wheel.updateValue();
    wheel.step(0);
    this.toggleMatrixNumbers($matrix);
  };

  svs.tur.EJBoards.prototype.toggleMatrixNumbers = function($matrix) {
    var className,
      self = this;

    $matrix.find('span').each(function() {
      if (Number(this.dataset.value) === self.currentWheel.value) {
        className = 'selected';
      } else if (!self.boards[self.activeIndex].numberIsValid(this.dataset.value, self.currentWheel)) {
        className = 'disabled';
      } else {
        className = '';
      }
      $(this).attr('class', className);
    });
  };

  svs.tur.EJBoards.Defaults = {
    minValue: 1,
    maxValue: 50,
    extraMaxValue: 12,
    className: '',
    spacingFactor: 5.5,
    repeat: 0,
    callback: undefined,
    onBoardChanged: undefined,
    onWheelChanged: undefined,
    onHuxfluxComplete: undefined,
    useFallback: (function() {
      if (svs.core.data.capabilities.browser === 'msie' || svs.core.data.capabilities.browser === 'trident') {
        return true;
      }

      var divTest = document.createElement('div');
      var canPreserve = false;

      if (divTest.style['transform-style'] !== undefined) {
        divTest.style['transform-style'] = 'preserve-3d';
        canPreserve = divTest.style['transform-style'] === 'preserve-3d';
      } else if (divTest.style['-webkit-transform-style'] !== undefined) {
        divTest.style['-webkit-transform-style'] = 'preserve-3d';
        canPreserve = divTest.style['-webkit-transform-style'] === 'preserve-3d';
      } else if (divTest.style.transformStyle !== undefined) {
        divTest.style.transformStyle = 'preserve-3d';
        canPreserve = divTest.style.transformStyle === 'preserve-3d';
      }

      return !canPreserve;
    })()
  };
})(svs);


 })(window);